import { TrackJSInstallOptions } from 'trackjs'
import { isOnProduction } from '@/config/base'

export const trackerConfig: TrackJSInstallOptions = {
  token: '7367ab9f605d4077ad4e7e56af6f06ed',
  enabled: isOnProduction(),
  application: 'public-projects-ssr',
  console: { enabled: true },
  network: {
    enabled: true,
    error: false
  },
  visitor: {
    enabled: true
  },
  window: {
    enabled: true,
    promise: false
  }
}
